import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetSurveysBySociogramId = sociogramId => {
  const query = useApiQuery(
    ['sociogram', 'surveysBySociogramId', sociogramId],
    'sociogram',
    `/surveys?sociogram_id=${sociogramId}`,
    { enabled: !!sociogramId }
  )

  return {
    isLoading: query.isLoading || query.isFetching,
    data: query.data ?? null,
    error: query.isError ? query.error : null,
    getSurveys: query.refetch
  }
}
